import React, { Component } from 'react';
import Header from '../components/Header';
import Bugsnag from '../helpers/bugsnag';
import withUser from '../common/withUser';
import withLoader from '../common/withLoader';
import {
  updateUsersSettings,
  getUsersSettings
} from '../utils/utils';
import {
  storeLastVisitedRoute,
  storeUser,
  storeVersionCode,
  storeThemeColor,
  storeThemeColorNumber,
  _getPreferredColorScheme,
} from '../common/globals';
import withFirstLoginSessionToken from '../common/withFirstLoginSessionToken';
import withNotify from '../common/withNotify';
import withUpdatedRoute from '../common/withUpdatedRoute';
// import { APP_VERSION } from '../common/config';
import withThemeColor from '../common/withThemeColor';
import withThemeDetectColor from '../common/withThemeDetectColor';
import withThemeNumber from '../common/withThemeNumber';

class Settings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isGroupByHospital: false,
      isBigCards: false,
      isPushNotifications: false,
      weekStart: '',
      themeNumber: '',
    };
  }

  _onSelectGroupByHospital = async (value) => {
    try {
      const {
        user, setLoader, notify, firstLoginSessionToken
      } = this.props;
      const { isGroupByHospital } = this.state;
      const settingsData = {
        isGroupByHospital: !isGroupByHospital,
        // lastAppVersion: APP_VERSION,
      };
      const getSettingsPayload = {
        userId: user.id,
        sessionToken: firstLoginSessionToken
      };
      let responseJson = {};
      setLoader(true);
      responseJson = await updateUsersSettings(settingsData, getSettingsPayload);
      const { status } = responseJson;
      if (status) {
        let getUserRes = await getUsersSettings(getSettingsPayload);
        if (getUserRes.status === true) {
          getUserRes = Object.assign(user, {
            isGroupByHospital: getUserRes.isGroupByHospital,
            isBigCards: getUserRes.isBigCards,
            isPushNotifications: getUserRes.isPushNotifications
          });
          await storeUser(getUserRes);
          await storeVersionCode();
        } else {
          notify({ type: 'error', message: getUserRes.message });
        }
      }
      setLoader(false);
      this.setState({ isGroupByHospital: !value });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onSelectIsBigCards = async (value) => {
    try {
      const {
        user, setLoader, notify, firstLoginSessionToken
      } = this.props;
      const { isBigCards } = this.state;
      const settingsData = {
        isBigCards: !isBigCards,
        // lastAppVersion: APP_VERSION,
      };
      const getSettingsPayload = {
        userId: user.id,
        sessionToken: firstLoginSessionToken
      };
      let responseJson = {};
      setLoader(true);
      responseJson = await updateUsersSettings(settingsData, getSettingsPayload);
      const { status } = responseJson;
      if (status) {
        let getUserRes = await getUsersSettings(getSettingsPayload);
        if (getUserRes.status === true) {
          getUserRes = Object.assign(user, {
            isGroupByHospital: getUserRes.isGroupByHospital,
            isBigCards: getUserRes.isBigCards,
            isPushNotifications: getUserRes.isPushNotifications
          });
          await storeUser(getUserRes);
          await storeVersionCode();
        } else {
          notify({ type: 'error', message: getUserRes.message });
        }
      }
      setLoader(false);
      this.setState({ isBigCards: !value });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onSelectWeekStartDay = async (value) => {
    const {
      user,
      setLoader,
      notify,
      setUser,
      firstLoginSessionToken
    } = this.props;
    try {
      const { weekStart } = this.state;
      if (weekStart === value) return;
      const settingsPayload = {
        userId: user.id,
        sessionToken: firstLoginSessionToken
      };
      const settingsData = {
        weekStart: value,
        // lastAppVersion: APP_VERSION,
      };
      setLoader(true);
      const responseJson = await updateUsersSettings(settingsData, settingsPayload);
      const { status } = responseJson;
      if (status) {
        const getUserRes = await getUsersSettings(settingsPayload);
        if (getUserRes.status === true) {
          const updatedUser = Object.assign(user, {
            isGroupByHospital: getUserRes.isGroupByHospital,
            isBigCards: getUserRes.isBigCards,
            isPushNotifications: getUserRes.isPushNotifications,
            weekStart: getUserRes.weekStart
          });
          await storeUser(updatedUser);
          await storeVersionCode();
          setUser(updatedUser);
          this.setState({ weekStart: value });
        } else {
          notify({ type: 'error', message: getUserRes.message });
        }
      }
    } catch (e) {
      Bugsnag.notify(e);
    } finally {
      setLoader(false);
    }
  }

  _onSelectIsIsPushNotification = async (value) => {
    try {
      const {
        user, setLoader, notify, firstLoginSessionToken
      } = this.props;
      const { isPushNotifications } = this.state;
      const settingsData = {
        isPushNotifications: !isPushNotifications,
        // lastAppVersion: APP_VERSION,
      };
      const getSettingsPayload = {
        userId: user.id,
        sessionToken: firstLoginSessionToken
      };
      let responseJson = {};
      setLoader(true);
      responseJson = await updateUsersSettings(settingsData, getSettingsPayload);
      const { status } = responseJson;
      if (status) {
        let getUserRes = await getUsersSettings(getSettingsPayload);
        if (getUserRes.status === true) {
          getUserRes = Object.assign(user, {
            isGroupByHospital: getUserRes.isGroupByHospital,
            isBigCards: getUserRes.isBigCards,
            isPushNotifications: getUserRes.isPushNotifications
          });
          await storeUser(getUserRes);
          await storeVersionCode();
        } else {
          notify({ type: 'error', message: getUserRes.message });
        }
      }
      setLoader(false);
      this.setState({ isPushNotifications: !value });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onSelectThemeColor = async (value) => {
    const {
      user,
      setLoader,
      notify,
      setUser,
      firstLoginSessionToken,
      setThemeColor,
      setThemeColorNumberSet,
      themeDetectColor
    } = this.props;
    try {
      const newValue = Number(value);
      const { themeNumber } = this.state;
      if (themeNumber === newValue) return;

      const settingsPayload = {
        userId: user.id,
        sessionToken: firstLoginSessionToken
      };

      const settingsData = {
        isDarkMode: newValue,
      };

      setLoader(true);
      const responseJson = await updateUsersSettings(settingsData, settingsPayload);
      const { status } = responseJson;
      if (status) {
        const getUserRes = await getUsersSettings(settingsPayload);
        if (getUserRes.status === true) {
          const updatedUser = Object.assign(user, {
            isGroupByHospital: getUserRes.isGroupByHospital,
            isBigCards: getUserRes.isBigCards,
            isPushNotifications: getUserRes.isPushNotifications,
            isDarkMode: getUserRes.isDarkMode
          });

          await storeUser(updatedUser);
          await storeVersionCode();
          setUser(updatedUser);
          this.setState({ themeNumber: newValue });

          setThemeColorNumberSet(newValue);
          await storeThemeColorNumber(newValue);
          if (newValue === 2) {
            setThemeColor(themeDetectColor);
            await storeThemeColor(themeDetectColor);
          } else if (newValue === 1) {
            setThemeColor('dark');
            await storeThemeColor('dark');
          } else {
            setThemeColor('light');
            await storeThemeColor('light');
          }

          await _getPreferredColorScheme();
        } else {
          notify({ type: 'error', message: getUserRes.message });
        }
      }
    } catch (e) {
      Bugsnag.notify(e);
    } finally {
      setLoader(false);
    }
  }

  async UNSAFE_componentWillMount() {
    try {
      const {
        user, firstLoginSessionToken, setLoader, setUpdatedRoute
      } = this.props;

      const getSettingsPayload = {
        userId: user.id,
        sessionToken: firstLoginSessionToken
      };
      setLoader(true);
      let getUserRes = await getUsersSettings(getSettingsPayload);
      getUserRes = Object.assign(user, {
        isGroupByHospital: getUserRes.isGroupByHospital,
        isBigCards: getUserRes.isBigCards,
        isPushNotifications: getUserRes.isPushNotifications,
        weekStart: getUserRes.weekStart,
        isDarkMode: getUserRes.isDarkMode
      });
      await storeUser(getUserRes);
      await storeVersionCode();
      this.setState({
        isGroupByHospital: user.isGroupByHospital,
        isBigCards: user.isBigCards,
        isPushNotifications: user.isPushNotifications,
        weekStart: user.weekStart,
        themeNumber: getUserRes.isDarkMode,
      });
      setLoader(false);
      storeLastVisitedRoute('/settings');
      setUpdatedRoute('/settings');
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const {
      isBigCards,
      isGroupByHospital,
      weekStart,
      themeNumber
    } = this.state;

    return (
      <section className="list-section sticky-top">
        <Header
          sideMenu
        />
        <section className="filter-section resizer-class">
          <div className="container">
            <div className="top-block">
              <div className="row">
                <div className="col">
                  <h4>Settings</h4>
                </div>
              </div>
            </div>
            <hr className="m-0" />

            <div className="row">
              <div className="col-12">
                <div className="topping day-filter-item">
                  <label className="cursor-pointer mt-2">
                    <input
                      type="checkbox" id="settings1"
                      name="hospital"
                      className="custom-check-bok"
                      value={isGroupByHospital}
                      checked={isGroupByHospital}
                      onChange={() => this._onSelectGroupByHospital(isGroupByHospital)}
                    />
                    <span className="me-2" />
                    Group by Hospital
                  </label>
                </div>
              </div>

              <div className="col-12">
                <div className="topping day-filter-item">
                  <label className="cursor-pointer mt-2 mb-2">
                    <input
                      type="checkbox" id="settings2"
                      name="caseCard"
                      className="custom-check-bok"
                      value={isBigCards}
                      checked={isBigCards}
                      onChange={() => this._onSelectIsBigCards(isBigCards)}
                    />
                    <span className="me-2" />
                    Big cards
                  </label>
                </div>
              </div>

              <div className="col-12">
                <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                  Week starts on:
                  <div style={{
                    display: 'flex',
                    gap: '10px',
                    alignItems: 'center'
                  }}
                  >
                    <label className="cursor-pointer mt-2 mb-2">
                      <input
                        type="checkbox" id="week-starts-sunday"
                        name="caseCard"
                        className="custom-check-bok"
                        value="Sunday"
                        checked={weekStart === 'Sunday'}
                        onChange={(e) => this._onSelectWeekStartDay(e.target.value)}
                      />
                      <span className="me-2" />
                      Sunday
                    </label>
                    <label className="cursor-pointer mt-2 mb-2">
                      <input
                        type="checkbox" id="week-starts-sunday"
                        name="caseCard"
                        className="custom-check-bok"
                        value="Monday"
                        checked={weekStart === 'Monday'}
                        onChange={(e) => this._onSelectWeekStartDay(e.target.value)}
                      />
                      <span className="me-2" />
                      Monday
                    </label>
                  </div>
                </div>
              </div>

              {/* <div className="col-12"> */}
              {/*  <div className="topping day-filter-item mb-2"> */}
              {/*    <label className="cursor-pointer mt-2"> */}
              {/*      <input */}
              {/*        type="checkbox" id="settings3" */}
              {/*        name="notification" */}
              {/*        className="custom-check-bok" */}
              {/*        value={isPushNotifications} */}
              {/*        checked={isPushNotifications} */}
              {/* eslint-disable-next-line max-len */}
              {/*        onChange={() => this._onSelectIsIsPushNotification(isPushNotifications)} */}
              {/*      /> */}
              {/*      <span className="me-2" /> */}
              {/*      Push Notification */}
              {/*    </label> */}
              {/*  </div> */}
              {/* </div> */}

              <div className="col-12">
                <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                  App Theme:
                  <div
                    className="setting-theme"
                    style={{
                      display: 'flex',
                      gap: '10px',
                      alignItems: 'center'
                    }}
                  >
                    <div className="form-check form-check-inline mt-2 mb-2">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="isDarkMode"
                        id="isDarkModeLight"
                        value="0"
                        checked={themeNumber === 0}
                        onChange={(e) => this._onSelectThemeColor(e.target.value)}
                      />
                      <label
                        className="form-check-label cursor-pointer"
                        htmlFor="isDarkModeLight"
                      >Light
                      </label>
                    </div>

                    <div className="form-check form-check-inline mt-2 mb-2">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="isDarkMode"
                        id="isDarkModeDark"
                        value="1"
                        checked={themeNumber === 1}
                        onChange={(e) => this._onSelectThemeColor(e.target.value)}
                      />
                      <label
                        className="form-check-label cursor-pointer"
                        htmlFor="isDarkModeDark"
                      >Dark
                      </label>
                    </div>

                    <div className="form-check form-check-inline mt-2 mb-2">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="isDarkMode"
                        id="isDarkModeDevice"
                        value="2"
                        checked={themeNumber === 2}
                        onChange={(e) => this._onSelectThemeColor(e.target.value)}
                      />
                      <label
                        className="form-check-label cursor-pointer"
                        htmlFor="isDarkModeDevice"
                      >Find Device Theme
                      </label>
                    </div>

                  </div>
                </div>
              </div>

            </div>
          </div>
        </section>
      </section>
    );
  }
}

export default withFirstLoginSessionToken(
  withNotify(
    withLoader(
      withUser(
        withUpdatedRoute(
          withThemeDetectColor(
            withThemeColor(
              withThemeNumber(
                Settings
              )
            )
          )
        )
      )
    )
  )
);
